import React, { useState } from 'react'
import LogoImg from '../../../assets/login/logo.png'
import LeftArrow from '../../../assets/login/left_arrow.svg'
import ApiService from '../../../services/ApiService'

import {
  Container,
  MainText,
  Title,
  Logo,
  ReturnButton,
  FullLabel,
  FullInput,
  DoubleInputDiv,
  HalfDiv,
  LeftLabel,
  HalfInputLeft,
  RightLabel,
  HalfInputRight,
  Condition,
  ConditionIcon,
  InputButton,
} from './style'
import { Password } from 'primereact/password'

interface RegisterInfo {
  name: string
  email: string
  phone: string
  company: string
  cnpj: string
  password: string
}

interface RegisterScreenProps {
  setPage: (page: string) => void
}

const RegisterScreen: React.FC<RegisterScreenProps> = (props) => {
  const [accountInfo, setAccountInfo] = useState<RegisterInfo>({
    name: '',
    email: '',
    phone: '',
    company: '',
    cnpj: '',
    password: '',
  })

  const changePage = (_page: string) => {
    props.setPage(_page)
  }

  const handleLogin = async () => {
    if (
      accountInfo.name &&
      accountInfo.email &&
      accountInfo.phone &&
      accountInfo.company &&
      accountInfo.cnpj &&
      accountInfo.password
    ) {
      try {
        await ApiService.auth.register({
          name: accountInfo.name,
          email: accountInfo.email,
          phone: accountInfo.phone,
          company: accountInfo.company,
          cnpj: accountInfo.cnpj,
          password: accountInfo.password,
          adminUser: false,
          approved: 'pending',
          picture: '',
          permissions: []
        })
        window.location.href = '/pendingmessage'
      } catch (err) {
        console.log(err)
      }
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setAccountInfo({
      ...accountInfo,
      [name]: value,
    })
  }

  const SpecialCharacters = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>?~]/

  let SizeCondition = false
  const UpperCondition = /[A-Z]/.test(accountInfo.password)
  const SpecialCondition = SpecialCharacters.test(accountInfo.password)

  if (accountInfo.password.length >= 4 && accountInfo.password.length <= 24) {
    SizeCondition = true
  }

  return (
    <Container>
      <Logo src={LogoImg} alt='Logo da Dustre' />
      <Title>
        <ReturnButton
          onClick={() => {
            changePage('Main')
          }}
        >
          <img src={LeftArrow} alt='Botão de retorno' />
        </ReturnButton>
        <MainText> Faça seu cadastro </MainText>
      </Title>

      <form>
        <FullLabel>Nome do responsável</FullLabel>

        <FullInput
          name='name'
          type='text'
          value={accountInfo.name}
          onChange={handleChange}
        />

        <DoubleInputDiv>
          <HalfDiv>
            <LeftLabel>Email</LeftLabel>
            <HalfInputLeft
              name='email'
              type='text'
              value={accountInfo.email}
              onChange={handleChange}
            />
          </HalfDiv>
          <HalfDiv>
            <RightLabel>Telefone para contato</RightLabel>
            <HalfInputRight
              name='phone'
              type='text'
              value={accountInfo.phone}
              onChange={handleChange}
            />
          </HalfDiv>
        </DoubleInputDiv>

        <DoubleInputDiv>
          <HalfDiv>
            <LeftLabel>Empresa</LeftLabel>
            <HalfInputLeft
              name='company'
              type='text'
              value={accountInfo.company}
              onChange={handleChange}
            />
          </HalfDiv>
          <HalfDiv>
            <RightLabel>CNPJ</RightLabel>
            <HalfInputRight
              name='cnpj'
              type='text'
              value={accountInfo.cnpj}
              onChange={handleChange}
            />
          </HalfDiv>
        </DoubleInputDiv>

        <DoubleInputDiv>
          <HalfDiv>
            <LeftLabel>Senha</LeftLabel>
            <Password
              name='password'
              feedback={false}
              value={accountInfo.password}
              onChange={handleChange}
              toggleMask
            />
          </HalfDiv>
          <HalfDiv>
            <Condition className={SizeCondition ? 'active' : 'inactive'}>
              <ConditionIcon className={SizeCondition ? 'ok' : 'notok'} />
              Entre 4 e 24 caracteres
            </Condition>
            <Condition className={UpperCondition ? 'active' : 'inactive'}>
              <ConditionIcon className={UpperCondition ? 'ok' : 'notok'} />
              No mínimo uma letra maiúscula
            </Condition>
            <Condition className={SpecialCondition ? 'active' : 'inactive'}>
              <ConditionIcon className={SpecialCondition ? 'ok' : 'notok'} />
              No mínimo um número ou caractere especial
            </Condition>
          </HalfDiv>
        </DoubleInputDiv>

        <InputButton
          onClick={handleLogin}
          type='button'
          value='Cadastrar'
          disabled={!(SizeCondition && UpperCondition && SpecialCondition)}
        />
      </form>
    </Container>
  )
}

export default RegisterScreen
